import TCollapse from './collapse.vue'
import TCollapsePanel from './collapse-panel.vue'

TCollapse.install = Vue => {
  Vue.component(TCollapse.name, TCollapse)
}

TCollapsePanel.install = Vue => {
  Vue.component(TCollapsePanel.name, TCollapsePanel)
}

export {
  TCollapse,
  TCollapsePanel
}



// WEBPACK FOOTER //
// ./src/module/collapse/index.js